module.exports = __webpack_public_path__ + "img/5.8bee4a88.jpg";